export default __webpack_public_path__ + "static/media/69_mobile.5ee62267.jpg";